import { map } from 'lodash'
import { error } from '@/utils/alert'
import bus from '@/utils/eventBus'

export default {
  doConfirmedAll () {
    const ids = map(this.schedules, schedule => {
      return schedule.id
    })

    this.$resource.put(ids.toString() + '/confirmed')
      .then(({data}) => {
        bus.$emit('is-attended', {show: true})
        this.$emit('close', data)
      })
      .catch(() => {
        error('Ocorreu um erro ao confirmar este horário.')
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/index/components/confirmed/resources/methods.js